import { ARRAY_OPERATOR_OPTIONS, DATE_OPERATOR_OPTIONS, STRING_OPERATOR_OPTIONS } from 'core/table/interfaces/Filters'

const REGISTRANT_DATE_FILTER_COLUMNS = new Set(['signupDate', 'latestActivity'])

export const getRegistrantOperatorOptions = (column: string) => {
  if (REGISTRANT_DATE_FILTER_COLUMNS.has(column)) {
    return DATE_OPERATOR_OPTIONS
  }
  switch (column) {
    case 'firstName':
    case 'lastName':
    case 'email':
    case 'mobile':
    case 'name':
    case 'homePhoneNumber':
    case 'opportunity':
    case 'role':
    case 'shiftTime':
    case 'eventTime':
      return STRING_OPERATOR_OPTIONS
    case 'groups':
    case 'volunteerTags':
      return ARRAY_OPERATOR_OPTIONS
    default:
      return []
  }
}
